module.exports = __webpack_public_path__ + "c4df082f6a52ca7f6fce65f03a9bbc1b.svg";